import * as React from "react";
const SvgExpandsvg = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill={props?.fill || "#091E42"}
      d="M1.8 10.2h3.3q.383 0 .641.257a.86.86 0 0 1 .259.638.88.88 0 0 1-.259.643A.86.86 0 0 1 5.1 12H.9a.87.87 0 0 1-.641-.259A.87.87 0 0 1 0 11.1V6.9q0-.383.257-.641A.86.86 0 0 1 .895 6a.88.88 0 0 1 .643.259.86.86 0 0 1 .262.641zm8.4-8.4H6.9a.87.87 0 0 1-.641-.257A.86.86 0 0 1 6 .905a.88.88 0 0 1 .259-.643A.86.86 0 0 1 6.9 0h4.2a.87.87 0 0 1 .641.259A.87.87 0 0 1 12 .9v4.2a.87.87 0 0 1-.257.641.86.86 0 0 1-.638.259.88.88 0 0 1-.643-.259.86.86 0 0 1-.262-.641z"
    />
  </svg>
);
export default SvgExpandsvg;
